export const PREF_TOKEN = "bearerToken";
export const IS_INTRO = "/";
export const IS_LOGIN = "Login";
// API BASE URL
//export const BASE_URL = 'http://awseb-awseb-7dr1q517xpuu-538423593.af-south-1.elb.amazonaws.com/'
// export const BASE_URL = "http://dev.api.ulearn.imperoserver.in/";
// export const BASE_URL = "https://13f5-122-179-140-29.ngrok-free.app/";
// export const BASE_URL = "http://api.ulearn.tz/";
export const BASE_URL = "https://dev.api.ulearn.umart.tz/";
export const PAGE_LIMIT = 10;
export const APIkey = "AIzaSyCZM6UdTr5gMHzl412TkWhOwNXkc8fOB8A";

// API TYPES
export const GET = "GET";
export const GET_URL_PARAMS = "GET_URL_PARAMS";
export const GET_ID_PARAMS = "GET_ID_PARAMS";
export const GET_URL_ENCODED = "GET_URL_ENCODED";
export const GET_URL_ID_PARAMS = "GET_URL_ID_PARAMS";
export const POST = "POST";
export const POST_ID_PARAMS = "POST_ID_PARAMS";
export const POST_RAW = "POST_RAW";
export const POST_FORM = "POST_FORM";
export const POST_URL_ENCODED = "POST_URL_ENCODED";
export const POST_URL_PARAMS = "POST_URL_PARAMS";
export const POST_URL_ENCODED_ID_PARAMS = "POST_URL_ENCODED_ID_PARAMS";
export const MULTI_PART_POST = "MULTI_PART";
export const PATCH = "PATCH";
export const PATCH_ID = "PATCH_ID";
export const PATCH_FORM = "PATCH_FORM";
export const PATCH_FORM_ID = "PATCH_FORM_ID";
export const PATCH_URL_ENCODED = "PATCH_URL_ENCODED";
export const PATCH_FORM_ID_URL_ENCODED = "PATCH_FORM_ID_URL_ENCODED";
export const MULTI_PART_ID_POST = "MULTI_PART";
export const MULTI_PART_ID_PATCH = "MULTI_PART_PATCH";
export const DELETE = "DELETE";
export const DELETE_URL_PARAMS = "DELETE_URL_PARAMS";
export const DELETE_URL_ENCODED = "DELETE_URL_ENCODED";
export const DELETE_ID_PARAMS = "DELETE_ID_PARAMS";
//Response
export const ResponseFail = 400;
export const ResponseSuccess = 200;
export const AuthError = 401;
export const Maintenance = 503;
//month
export const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
//
export const S3_BUCKET_NAME = "umart-development";
export const Region = "af-south-1";
export const accessKey = "AKIASJEBMGPUGBLITS7U";
export const secretKey = "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";